enum StapleModes {
  Create = 'create',
  Edit = 'edit'
};

export default StapleModes;
